import { useTranslation } from '@web_opxp/features';
import * as React from 'react';
import { connect } from 'react-redux';
import { SKELETON_CLASSNAME, SKELETON_DUMMYTEXT } from '../../base/constants';
import { EDomain } from '../../base/types';
import ExercisesContainer from '../../components/exercises/ExercisesContainer';
import { Selectors as ExercisesSelectors, Types as ExercisesTypes } from '../../exercises';
import { IState } from '../../store/state';
import EvaluationExercisesCard from './EvaluationExerciseCard';
import './EvaluationExercises.scss';

interface IOwnProps {
  domain: EDomain | null;
  userId?: number;
}

export interface IDomainExercisesProps extends IOwnProps {
  exercises: ExercisesTypes.IExercise[];
}

export const EvaluationExercisesFC: React.FC<IDomainExercisesProps> = ({ exercises, domain, userId }) => {
  const { t } = useTranslation();
  let skeletonClass = SKELETON_CLASSNAME;
  let domainName = '';
  let cardsTitle = SKELETON_DUMMYTEXT;
  if (domain) {
    skeletonClass = '';
    domainName = t(`common:Domain.Title.${domain}`);
    cardsTitle = userId
      ? t(`Evaluation.CardsTitle.User`, { domain: domainName })
      : t(`Evaluation.CardsTitle.Title`, { domain: domainName });
  }
  return (
    <ExercisesContainer title={cardsTitle} skeletonClass={skeletonClass} className="evaluation-exercises-container">
      {exercises.map((exercise) => (
        <EvaluationExercisesCard key={exercise.exerciseId} {...exercise} />
      ))}
    </ExercisesContainer>
  );
};

export const mapStateToProps = (state: IState, props: IOwnProps) => {
  const { domain, userId } = props;
  let exercises: ExercisesTypes.IExercise[] = [];
  if (domain) {
    exercises = ExercisesSelectors.getDomainExercises(state, domain, userId);
  }
  return {
    exercises,
  };
};

const EvaluationExercises = connect(mapStateToProps)(EvaluationExercisesFC);
export default EvaluationExercises;
